import { render, staticRenderFns } from "./BaseSalePricePopup.vue?vue&type=template&id=e810cf64"
import script from "./BaseSalePricePopup.vue?vue&type=script&lang=js"
export * from "./BaseSalePricePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports